import { Injectable } from '@angular/core';
import { ClipboardService, IClipboardResponse } from 'ngx-clipboard';
import { take } from 'rxjs/operators';
import { SnackService } from '../../snack.service';

@Injectable({
  providedIn: 'root'
})
export class ClipboardWrapperService {
  constructor(
    private clipboardService: ClipboardService,
    private snackService: SnackService
  ) {}

  public copyToClipboard<T>(toCopy: T): void {
    const promise = this.clipboardService.copyResponse$
      .pipe(take(1))
      .toPromise();
    this.clipboardService.copy(
      typeof toCopy === 'string' ? toCopy : toCopy.toString()
    );
    promise.then((res: IClipboardResponse) => {
      if (res.isSuccess) {
        this.snackService.showSuccess('Succesvol gekopieerd naar klembord');
      } else {
        this.snackService.showError('Kon niet kopiëren naar klembord');
      }
    });
  }
}
